import { StandardEvents } from '@shopify/events';
(() => {
  const setupShelves = (root = document) => {
    root.querySelectorAll('[data-fr-shelf]').forEach(shelf => {
      const track = shelf.querySelector('[data-fr-track]');
      const previous = shelf.querySelector('[data-fr-prev]');
      const next = shelf.querySelector('[data-fr-next]');
      if (!track || track.dataset.frReady) return;
      track.dataset.frReady = 'true';
      const update = () => {
        if (previous) previous.disabled = track.scrollLeft < 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      const move = direction => track.scrollBy({left: direction * track.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };
  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-fr-quantity]');
    if (quantityButton) {
      const input = quantityButton.parentElement.querySelector('input');
      const step = Number(input.step) || 1;
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      const value = Number(input.value) || min;
      input.value = Math.min(max, Math.max(min, value + Number(quantityButton.dataset.frQuantity) * step));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    const thumbnail = event.target.closest('[data-fr-image]');
    if (thumbnail) {
      const gallery = thumbnail.closest('.fr-product-gallery');
      const image = gallery.querySelector('.fr-product-main-image');
      if (image) { image.src = thumbnail.dataset.frImage; image.removeAttribute('srcset'); }
      gallery.querySelectorAll('[data-fr-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
    }
    document.querySelectorAll('.fr-departments[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.fr-departments[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-fr-variant]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    const product = select.closest('[data-fr-product]');
    const price = product.querySelector('[data-fr-price]');
    const compare = product.querySelector('[data-fr-compare]');
    const buy = product.querySelector('[data-fr-buy]');
    if (price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true'; }
    if (buy) { buy.disabled = option.dataset.available !== 'true'; buy.textContent = buy.disabled ? 'Esgotado' : 'Comprar'; }
    const image = product.querySelector('.fr-product-main-image');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    const quantity = product.querySelector('input[name="quantity"]');
    if (quantity) {
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      quantity.max = option.dataset.max || '';
      quantity.value = quantity.min;
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', select.value);
    history.replaceState(null, '', url);
  });
  const refreshCartHeader = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-fr-cart-count]').forEach(node => node.textContent = cart.item_count);
      const amount = new Intl.NumberFormat('pt-BR', {style:'currency', currency:cart.currency || 'BRL'}).format(cart.total_price / 100);
      document.querySelectorAll('[data-fr-cart-total]').forEach(node => node.textContent = amount);
    } catch {}
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    Promise.resolve(event.promise).then(refreshCartHeader).catch(() => {});
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCartHeader(); });
  setupShelves();
  document.addEventListener('shopify:section:load', event => setupShelves(event.target));
})();
